import { stringify } from 'query-string';
import { IGetVillageListRequestSchema } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { parseQueryString } from './filters';

export function getUnknownQuery(query: string, filters: IGetVillageListRequestSchema) {
  const queryMap = parseQueryString(query);

  if (!queryMap) {
    return '';
  }

  const map = Object.entries(queryMap).reduce((acc, [key, value]) => {
    if (filters.hasOwnProperty(key) || !key || value == null) {
      return acc;
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {});

  return stringify(map);
}
